/**
 * 找样详情
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2024/6/13      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */
import React from 'react'
import PropTypes from "prop-types";
import Info from "../components/Info";
import "./index.less";
import {Empty,Spin,Pagination,message} from 'antd';
import Contact from "./components/Contact";
import Lang from "@components/Lang/Lang"
import qs from 'query-string';
import dayjs from 'dayjs';
import Item from './components/Item';
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import request from "../../../../utils/request";
import PageCommon from  "@components/PageCommon/PageCommon";
class Page extends React.Component{
    constructor(props) {
        super(props);
        const searchObj = qs.parse(props.location.search)||{}
        this.state = {
            loading:false,
            extra:{},
            model: {},
            list:[],
            pagingQuery:{
                pageSize:9999, //需求临时说不需要分页，所以后端说这里取一个很大的值
                pageIndex:1,
                total:0
            },
            source:searchObj.source
        }
        this.id = (qs.parse(props.location.search) || {}).id;
    }

    onRefPageCommon = (ref) => this.onRefPageCommonChild = ref;

    /**
     * 切换分页
     * @param page 切换到第几页
     * @param pageSize
     **/
    onChangePage(page, pageSize){
        this.getData(page, pageSize)
    }

    /**
     * 找样详情
     **/
    getData(){
        request.post(
            "/service/mg/fuzzy/details",
            {
                id:this.id
            }
        ).then((response) => {
            const res = response.data;
            if(res.success&&res.valid){
                this.setState({
                    model:res.model||{},
                    extra:res.extra||{},
                })
            }
        });
    }

    /**
     * 获取商品数据
     **/
    getGoodsData(pageIndex){
        this.setState({
            loading:true,
        },()=>{
            var state = {
                loading:false
            };
            request.post(
                "/service/mg/fuzzy/details-goods-list",
                {
                    fuzzySampId:this.id,
                    pagingQuery:{
                        pageIndex: pageIndex||this.state.pagingQuery.pageIndex,
                        pageSize: this.state.pagingQuery.pageSize
                    }
                }
            ).then((response) => {
                const res = response.data;
                if(res.success&&res.valid){
                    state.list = res.models||[];
                }
                if(res.paging){
                    state.pagingQuery = {
                        pageIndex:res.paging&&res.paging.pageNum,
                        pageSize:res.paging&&res.paging.pageSize,
                        total:res.paging&&res.paging.total
                    }
                }
                this.setState(state,()=>{
                    this.onRefPageCommonChild.isShowTop();
                });
            },()=>{
                this.setState(state);
            });
        })
    }

    /**
     * 切换分页
     * @param page 当前页面
     * @param pageSize 分页大小
     */
    onChangePage = (page, pageSize) => {
        this.setState({
            pagingQuery: {
                pageSize: pageSize,
                pageIndex: page
            }
        }, () => {
            this.getGoodsData();
        })
    }

    /**
     * 获取状态
     * @param item
     * @return {null|*}
     */
    getStatusHtml(item){
        if(item.status=='15'){
            return <div className="status-label status-label15">
                {__getServerLanguage('ZhaoYangZhong')}
            </div>
        }else if(item.status=='20'){
            return <div className="status-label status-label20">
                {__getServerLanguage('YouZhaoDao')}
            </div>
        }else if(item.status=='50'){
            return <div className="status-label status-label50">
                {__getServerLanguage('RenWuWanCheng')}
            </div>
        }else if(item.status=='40'){
            return <div className="status-label status-label40">
                {__getServerLanguage('YiQuXiao')}
            </div>
        }
        return null;
    }

    getPercentage(model){
        let all = model.effectiveEndTime - model.effectiveStartTime;
        let consume = model.currentTime - model.effectiveStartTime;
        return ((consume/all)*100).toFixed(2)+'%';
    }

    getEmptyText(model){
        let text = __getServerLanguage('YiFenXiXuQiuPinLeiJingLiZ');
        switch (model.status) {
            case '40':
                text = __getServerLanguage('ZanWuShangPin');
                break;
            case '50':
                text = __getServerLanguage('BaoQianWoMenMeiYouZhaoDao');
        }
        return text;
    }

    componentDidMount() {
        this.getData();
        this.getGoodsData();
    }

    render(){
        const state = this.state;
        const {list,model,pagingQuery,extra,source} = this.state;
        const {buyerVO={}} = model;
        const crumb = [
            source=="sampleList"?{name:  Lang({id: "ZhaoYangGuanLiGuoWai",default: "找样管理（国外）"}),link:`/customer/sampleList`}:{name:  Lang({id: "ZhangHaoXiangQing",default: "客户详情"}),link:`/customer/detail?id=${buyerVO.id}`},
            {name: Lang({id:'KeHuDeZhaoYang',default:"客户的找样"})}
        ];
        return (
            <PageCommon onRef={this.onRefPageCommon} showTop={true}>
                <CommonBreadcrumb list={crumb}></CommonBreadcrumb>
                <div className="wp-box">
                    <div className="color089 font_16 lineH_150p fw_700 mb_12">{__getServerLanguage('NDeZhaoYang',buyerVO.code)}</div>
                    <Info model={model}
                          fuzzyId={this.id}></Info>

                    <Spin spinning={this.state.loading}>
                        <div className="fuzzy-detail__wrap">
                            <div className="flex-box ant-row-flex-space-between mb_12">
                                <div className="flex-box">
                                    <Contact fuzzyId={this.id}
                                             title={__getServerLanguage('LianXiKeHu')}
                                             model={model}
                                             callback={this.getData.bind(this)}
                                             // showEdit={(model.recommendUserIds||[]).indexOf(extra.userId)!=-1&&model.status!='50'&&model.status!='40'}
                                             // 开放给海外客服可以去补充找样的条件，不限制发起跟客户的对话
                                             showEdit={true}
                                    >
                                        <a className="btn-contact mr_12">
                                            <i className="ri-message-2-line font_18 mr_4"></i>
                                            <span>{__getServerLanguage('LianXiKeHu')}</span>
                                            {
                                                model.messageCount?
                                                    <span className={`num ${model.isNewMessage?'num-red':'num-green'}`}>
                                                    {model.messageCount}
                                                </span>
                                                    :
                                                    null
                                            }

                                        </a>
                                    </Contact>
                                    {
                                        (model.status!='40'&&model.status!='50')?
                                            <span className="btn-rate">
                                                <div className="bg-per mr_4" style={{width:this.getPercentage(model)}}></div>
                                                <div className="btn-rate__content">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                                        <path d="M4.5 3H3V1.5H15V3H13.5V4.5C13.5 5.71157 12.8878 6.68601 12.1171 7.4825C11.5899 8.02725 10.9485 8.529 10.2982 9C10.9485 9.471 11.5899 9.97275 12.1171 10.5175C12.8878 11.314 13.5 12.2885 13.5 13.5V15H15V16.5H3V15H4.5V13.5C4.5 12.2885 5.11212 11.314 5.88293 10.5175C6.41012 9.97275 7.05152 9.471 7.70183 9C7.05152 8.529 6.41012 8.02725 5.88293 7.4825C5.11212 6.68601 4.5 5.71157 4.5 4.5V3ZM6 3V4.5C6 5.01385 6.19519 5.50124 6.57848 6H11.4215C11.8048 5.50124 12 5.01385 12 4.5V3H6ZM9 9.91642C8.2161 10.4701 7.506 10.9972 6.96083 11.5606C6.81756 11.7087 6.69005 11.8548 6.57848 12H11.4215C11.3099 11.8548 11.1824 11.7087 11.0392 11.5606C10.494 10.9972 9.7839 10.4701 9 9.91642Z" fill="#E24E1D"/>
                                                    </svg>
                                                    <span className="mr_4">
                                                        {__getServerLanguage('QianWanChengHuiFu',model.effectiveEndTime?dayjs(model.effectiveEndTime).format('YYYY.MM.DD'):'-')}
                                                    </span>
                                                </div>
                                            </span>
                                            :
                                            null
                                    }
                                </div>
                                {this.getStatusHtml(model)}
                            </div>
                            {
                                list.length==0?
                                    <Empty className="mt_16 mb_16" description={
                                        this.getEmptyText(model)
                                    }></Empty>
                                    :
                                    null
                            }
                            {
                                pagingQuery.total>0?
                                    <div className="fuzzy-detail__main">
                                        {/*为你找到的样品，共{pagingQuery.total}款*/}
                                        <p className="color066 font_14 lineH_150p mb_4">{__getServerLanguage('WeiNiZhaoDaoDeYangPinGong',pagingQuery.total)}</p>
                                        <div className="fuzzy-detail__list-wrap">
                                            {
                                                list.map((item,index)=>{
                                                    return <Item key={index} currencySymbol={buyerVO.currencySymbol} item={item}></Item>
                                                })
                                            }
                                        </div>
                                    </div>
                                    :
                                    null
                            }
                        </div>
                        {/*{
                        pagingQuery.total>0?
                            <div className="text-center mt_12">
                                <Pagination
                                    current={pagingQuery.pageIndex || 1}
                                    pageSize={pagingQuery.pageSize||50}
                                    total={pagingQuery.total || 0}
                                    onChange={this.onChangePage.bind(this)}
                                />
                            </div>
                            :
                            null
                    }*/}

                    </Spin>
                </div>
            </PageCommon>
        )
    }
}

Page.defaultProps = {
}

Page.propTypes = {

}
export default Page;
